// /components/ChatPage/EmptyState.tsx
import React from "react";
import { MailOpen } from "lucide-react";

interface Props {
  t: (k: string) => string;
}

const EmptyState: React.FC<Props> = ({ t }) => (
  <div className="flex flex-col justify-center items-center h-full">
    <MailOpen className="h-16 w-16" stroke="#6F7D95" strokeWidth={1} />
    <p className="text-gray-500 mt-4">{t("no_messages_to_display")}</p>
  </div>
);

export default EmptyState;
